module.exports = __webpack_public_path__ + "media/自然界声音-动物声音-狗叫声.7bb13997.wav";